import { motion } from 'motion/react';

export type OrderArrowProps = {
  ringSize: number;
  ringR: number;
  count: number;
};

/** Chevron that snaps seat-to-seat clockwise with a dwell at each stop. */
export const OrderArrow = ({ ringSize, ringR, count }: OrderArrowProps) => {
  const cx = ringSize / 2;
  const cy = ringSize / 2;
  const orbitR = ringR + 22;

  const dwell = 1.7;
  const travel = 0.5;
  const total = count * (dwell + travel);

  const keyframes: number[] = [0];
  const times: number[] = [0];
  let cursor = 0;
  for (let i = 1; i <= count; i += 1) {
    const angle = (i * 360) / count;
    cursor += dwell;
    keyframes.push(0 + ((i - 1) * 360) / count);
    times.push(cursor / total);
    cursor += travel;
    keyframes.push(angle);
    times.push(cursor / total);
  }

  return (
    <motion.div
      aria-hidden
      className="pointer-events-none absolute"
      style={{
        left: cx,
        top: cy,
        width: 0,
        height: 0,
      }}
      animate={{ rotate: keyframes }}
      transition={{ duration: total, times, repeat: Number.POSITIVE_INFINITY, ease: 'easeInOut' }}
    >
      <div
        className="absolute"
        style={{
          transform: `translate(-50%, -50%) translateY(-${orbitR}px)`,
        }}
      >
        <svg width="22" height="22" viewBox="0 0 22 22" role="img" aria-hidden>
          <title>order direction</title>
          <path
            d="M3 11 H17 M12 6 L18 11 L12 16"
            fill="none"
            stroke="var(--color-ink)"
            strokeWidth="2.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    </motion.div>
  );
};
